// pages/About.js
import React from 'react';

function About() {
  return (
    <div className="about-page">
      <section className="page-header">
        <div className="container">
          <h1>About Esseltech Engineering</h1>
          <p>Engineering excellence for a safer tomorrow</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="overview-container">
            <div className="about-content">
              <h2 className="section-title">Company Overview</h2>
              <div style={{ display: 'flex', gap: '30px', alignItems: 'flex-start' }}>
                <div className="overview-image" style={{ flex: '0 0 300px' }}>
                  <img src="/images/company_overview.png" alt="Esseltech Corporate Engineering Headquarters" className="overview-image-content" style={{ height: '350px' }} />
                </div>
                <div className="overview-text-content" style={{ flex: 1 }}>
                  <p>
                    ESSELTECH Engineering (Private) Limited is a Sri Lankan engineering solutions company established in July 2016, specializing in integrated Building Services Engineering. The company delivers end-to-end solutions across MEP (Mechanical, Electrical & Plumbing), ELV (Extra Low Voltage), and Fire Life Safety Systems for a wide range of sectors including commercial, residential, hospitality, industrial, and irrigation developments.
                  </p>
                  <p>
                    With a commitment to quality, innovation, and reliability, ESSELTECH Engineering has positioned itself as a trusted provider of engineering systems that enhance safety, efficiency, and sustainability in modern infrastructure projects.
                  </p>
                  <h3 style={{ marginTop: '20px', marginBottom: '10px' }}>Company Background</h3>
                  <p>
                    Founded by a team of experienced professionals with extensive local and international project exposure, ESSELTECH was built on the vision of providing world-class engineering solutions tailored to Sri Lankan and regional market needs.
                  </p>
                  <p>
                    The founding team, together with strategic partners, has played a significant role in the design, supply, installation, testing, and commissioning of landmark projects across the globe. Their collective expertise allows the company to bring global standards and proven technologies into local developments.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{ background: 'var(--light-gray)' }}>
        <div className="container">
          <div className="mission-vision-grid">
            <div className="mission-card">
              <h3>Our Mission</h3>
              <p>
                To protect lives and property by providing innovative, reliable, and
                cost-effective fire safety and engineering solutions that exceed client
                expectations and meet international standards.
              </p>
            </div>
            <div className="vision-card">
              <h3>Our Vision</h3>
              <p>
                To become Sri Lanka's most trusted engineering solutions provider,
                recognized for technical excellence, innovation, and unwavering commitment
                to safety and quality.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">Future Development Goals</h2>
          <div className="goals-timeline">
            <div className="goal-item">
              <div className="goal-year">2024</div>
              <div className="goal-content">
                <h3>Launch Building Electrical Systems Division</h3>
                <p>Expanding services to include comprehensive electrical solutions for modern buildings</p>
              </div>
            </div>
            <div className="goal-item">
              <div className="goal-year">2025</div>
              <div className="goal-content">
                <h3>Introduce Security Systems Integration</h3>
                <p>Adding CCTV, access control, and integrated security solutions to our portfolio</p>
              </div>
            </div>
            <div className="goal-item">
              <div className="goal-year">2026</div>
              <div className="goal-content">
                <h3>Regional Expansion</h3>
                <p>Opening branch offices in Kandy and Galle to serve clients across Sri Lanka</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{ background: 'var(--light-gray)' }}>
        <div className="container">
          <h2 className="section-title">Our Engineering Expertise</h2>
          <div className="expertise-grid">
            <div className="expertise-card">
              <h3>Fire Safety Engineering</h3>
              <p>Certified fire protection engineers with international accreditation</p>
            </div>
            <div className="expertise-card">
              <h3>Electrical Engineering</h3>
              <p>Licensed electrical engineers for building systems design</p>
            </div>
            <div className="expertise-card">
              <h3>Security Systems</h3>
              <p>Specialists in integrated security solutions</p>
            </div>
            <div className="expertise-card">
              <h3>Project Management</h3>
              <p>PMP certified project managers for seamless execution</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;